import styles from "./styles.module.css";
import type { IconType } from "react-icons";
import { Link } from "react-router-dom";
import NumberFlow from "@number-flow/react";
import { motion } from "motion/react";
import { forwardRef } from "react";
import { ArrowUpRight } from "lucide-react";

type Colors = "green" | "crimson" | "cyan" | "purple" | "gold";

export interface AnalyticsProps {
  color: Colors;
  Icon: IconType;
  count: number;
  title: string;
  url: string;
  colorInner: string;
  position: number;
}

const AnalyticsCard = forwardRef<HTMLAnchorElement, AnalyticsProps>(
  ({ Icon, color, count, title, url = "/#", position }, ref) => {
    return (
      <Link to={url} className={styles.cardLink} ref={ref}>
        <motion.article
          className={`${styles.card} ${styles[color]}`}
          initial={{ opacity: 0, y: 18, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{
            delay: position * 0.06,
            duration: 0.45,
            ease: "easeOut",
          }}
          whileHover={{ y: -6 }}
        >
          <div className={styles.cardGlow} aria-hidden="true" />

          <div className={styles.cardTop}>
            <div className={styles.iconBox}>
              <Icon size={22} aria-hidden="true" />
            </div>

            <span className={styles.viewIcon}>
              <ArrowUpRight size={17} aria-hidden="true" />
            </span>
          </div>

          <div className={styles.cardBody}>
            <div className={styles.count}>
              <NumberFlow value={count || 0} />
            </div>

            <p className={styles.title}>{title}</p>
          </div>

          <div className={styles.cardBottom}>
            <span>View details</span>
            <div className={styles.progressTrack}>
              <div className={styles.progressBar} />
            </div>
          </div>
        </motion.article>
      </Link>
    );
  },
);

AnalyticsCard.displayName = "AnalyticsCard";

export default AnalyticsCard;
